/**
 * @flow
 */
'use strict';

import AsyncStorage from '@react-native-async-storage/async-storage';
import Moment from 'moment';
import LocalizedStrings from 'react-native-localization';
import { cacheDefinitions } from './Items';

export const strings = new LocalizedStrings({
  en: {
    enterRegisteredEmail:
      'Please enter your email address to connect to your WINK database\nor try with a demo database',
    trialWarning:
      'This is a demo version that uses a public shared database. Do not enter any real patient data.',
    winkLink: 'Visit www.winksoftware.com to learn more',
    emailAdres: 'Email address',
    connectToPms: 'Connect',
    tryForFree: 'Try it out',
    answerSecurityQuestion:
      'Please answer the security question before submitting',
    submitSecurityAnswer: 'Send',
    unRegisteredEmail: 'This email address was not registered before with Wink',
    userName: 'User name',
    password: 'password', // NOSONAR
    enterCode: 'Enter Code',
    submitLogin: 'Login',
    verifyCode: 'Verify',
    touchNotConfigured:
      'Your account is not set up to use the mobile app yet. Please contact customer support.',
    registrationScreenTitle: 'WINKemr registration',
    loginscreenTitle: 'WINKemr login',
    mfaCodeVerificationTitle: 'WINKemr code verification',
    mfaCodeScanTitle: 'WINKemr QR Code scan',
    mfaCodeScanned: 'I have scanned the code',
    account: 'Account',
    store: 'Store',
    securityQuestionsError:
      'Something went wrong trying to get the security question from the server. Please try again.',
    registrationError:
      'Something went wrong trying to get the app version from the server. Please try again.',
    fetchAccountsError:
      'Something went wrong trying to get the accounts from the server. Please try again.',
    loginFailed: 'Login failed',
    calendar: 'Calendar',
    patient: 'Patient',
    back: 'Back',
    graph: 'Graph',
    history: 'History',
    template: 'Template',
    templates: 'Templates',
    settings: 'Settings',
    openFile: 'Patient file',
    startAppointment: 'Start visit',
    addVisit: 'Add consultation',
    createPatient: 'Create patient',
    logout: 'Logout',
    newPatient: 'New patient',
    newDoctor: 'Add a doctor',
    newAppointment: 'Reserve Appointment',
    preExams: 'Pre test',
    exams: 'Exams',
    odSphere: 'OD Sphere',
    odCylinder: 'OD Cylinder',
    odAxis: 'OD Axis',
    odBase: 'OD Base',
    odPrism: 'OD Prism',
    odAdd: 'OD Add',
    osSphere: 'OS Sphere',
    osCylinder: 'OS Cylinder',
    osAxis: 'OS Axis',
    osBase: 'OS Base',
    osPrism: 'OS Prism',
    osAdd: 'OS Add',
    allNormal: 'All normal',
    othersNormal: 'Others normal',
    paperForm: 'Paper form',
    predefinedOptions: 'Predefined options',
    selectionLists: 'Selection lists',
    groupedForm: 'Grouped form',
    refractionTest: 'Refraction test',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    extraLarge: 'Extra large',
    duplicate: 'Duplicate',
    serverError:
      'Something went wrong on the server. Please try again.\n\n(Internal error = {0})',
    pending: 'Pending',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    noShow: 'No Patient',
    waiting: 'Waiting',
    waitingList: 'Waiting List',
    waitingListComment: 'Waiting List Comment',
    completed: 'Completed',
    start: 'Start',
    scheduledAt: 'Scheduled at',
    forDuration: 'for',
    end: 'End',
    duration: 'Duration',
    minutes: 'minutes',
    minute: 'minute',
    hours: 'hours',
    day: 'day',
    days: 'days',
    halfAnHour: 'half an hour',
    status: 'Status',
    doctor: 'Doctor',
    now: 'Now',
    today: 'Today',
    yesterday: 'Yesterday',
    beforeYesterday: 'Before yesterday',
    tomorrow: 'Tomorrow',
    in2Days: 'In 2 days',
    lockVisit: 'Lock',
    complete: 'Complete',
    years: 'years',
    ageM: 'age',
    ageF: 'age',
    recall: 'Recall',
    noAccountsWarning:
      'There are no accounts compatible with this version of WINKemr.',
    sign: 'Sign',
    signed: 'Signed',
    diagnosis: 'Diagnosis',
    referral: 'Referral',
    finalRx: 'Final Rx',
    printRx: 'Print Rx',
    transferRx: 'Share Rx',
    printClRx: 'Print ClRx',
    printReferral: 'Print Referral',
    printMedicalRx: 'Print Medical Rx',
    printWithoutSign: 'Print without signature',
    printPatientFile: 'Print Patient File',
    patientFile: 'Patient File',
    add: 'Add',
    remove: 'Remove',
    od: 'OD',
    os: 'OS',
    ou: 'OU',
    far: 'Far',
    near: 'Near',
    dva: 'DVA',
    nva: 'NVA',
    maxLengthError: 'Too much text',
    minLengthError: 'Not enough text',
    requiredError: 'Mandatory',
    resume: 'Summary',
    restart: 'Restart',
    addFavorite: 'Add favorite',
    clear: 'Clear',
    favorites: 'Common',
    notStarted: 'New exam',
    copyToFinal: 'Final Rx',
    update: 'Update',
    errorTitle: 'Error',
    errorsTitle: 'Errors',
    validationErrorMessage: 'Please verify all fields contain valid values.',
    refractionTitle: 'Rx',
    removeItemError: 'Please clear all the data before removing this item.',
    unsupportedDocumentError: 'Document {0} can not be displayed.',
    documentTrailTitle: '{0}',
    medicationRxTitle: 'Medication Rx',
    summaryTitle: 'Summary',
    fetchItemError:
      'Something went wrong trying to get {0} data from the server. Please try again.\n\n(Internal error = {1})',
    storeItemError:
      'Something went wrong trying to save {0} data on the server.\n\n(Internal error = {1})',
    initialiseError:
      'Something went wrong while initialising. Please kill and restart the app.\n\n(Internal error fetching {0} = {1})',
    maximumAddableGroupError: 'You can not add more then {0} {1}.',
    doctorWithoutVisitTypeError:
      'Doctor {0} is not set up for the EMR yet in the database.',
    searchCriteriumMissingError: 'Please enter a search criterium.',
    noPatientsFound: 'No patients found',
    noDoctorsFound: 'No doctors found',
    drawingNotSavedWarning: 'Attention: Your last drawing was not saved.',
    scanEmailTitle: 'Patient file {0}',
    scanEmailBody:
      '<p>Please find attached the {0} for patient {1}.</p><p>Have a nice day</p><p>{2}</p>',
    emailAppUnavailableError: 'Please configure the iPad email app.',
    updateAppStore: 'Please update the WINKemr app in the apple appstore.',
    cancel: 'Cancel',
    confirm: 'Confirm',
    send: 'Send',
    deleteVisitTitle: 'Delete consultation',
    // deleteVisitQuestion:
    //   'Are you sure you want to permanently delete the {0} of {1} ?',
    deleteVisitQuestion:
      'This will permanently delete this consultation, including all diagnosis, procedures, notes, and results.  Are you absolutely sure?',
    deleteBoxText: 'Please enter <style1>delete</style1> in order to proceed',
    deleteText: 'delete',
    deletedVisitMessage: 'Cannot open deleted visits !',
    findPatient: 'Search by patient name or #Z',
    findDoctor: "Search by doctor's name",
    visit: 'Consultation',
    translate: 'Translate',
    stopTranslating: 'Stop translating',
    document: 'document',
    importDataQuestion: 'Please choose to import',
    configuration: 'Config',
    nameStar: 'Please give the star a name',
    during: 'During',
    drSignature: 'Signature',
    signedDate: 'Signed Date',
    futureVisitDateError: "You can't add a consultation in the future",
    saveImageError:
      'Something went wrong saving your {0} image in the database. Please try again.',
    pmsImageSaveError:
      'Something went wrong while saving your image in the PMS. You can try again.',
    examDate: 'Date of Exam',
    healthCard: 'Health Card',
    configMissing:
      'Please go back to the first page and configure the {0} you want to use via the Config menu button.',
    emailSuccess: 'Email sent successfully to {0}',
    faxSuccess: 'Fax sent successfully to {0}',
    referralSuccess: 'Referral sent successfully to {0}',
    referringPatientTo: 'Referring patient to ',
    doctorReferralMissing: 'Please select the doctor',
    digitalSignatureMissing:
      'Please insert and place your digital signature field first',
    followUpTitle: 'Follow Up',
    dynamicField: 'Dynamic field',
    findRow: 'Search',
    view: 'View',
    quickReply: 'Quick Reply',
    edit: 'Edit',
    resend: 'Resend',
    forward: 'Forward',
    noDataFound: 'No Existing Referral Letter !',
    deleteTitle: 'Delete',
    deleteReferralQuestion:
      'Are you sure you want to delete the referral {0} of {1} ?',
    manageUsers: 'Doctors',
    deleteReferralTitle: 'Delete referral',
    customisation: 'Customise',
    from: 'From',
    to: 'To',
    date: 'Date/Time',
    comment: 'Comment',
    itemNotSelected: 'No item was selected',
    importDataNotFound: 'No data found to import !',
    consultationDate: 'Consultation date',
    close: 'Close',
    apply: 'Apply',
    open: 'Open',
    select: 'Select',
    chooseDoctor: 'Choose Doctor',
    transferRxSuccess: 'Rx transferred successfully !',
    exportDataSuccess: 'Data exported successfully !',
    NoCameraAccess: 'No access to camera',
    flip: 'Flip',
    snapshot: 'Snapshot',
    somethingWentWrongTitle: 'Oops! Something went wrong.',
    somethingWentWrongMessage:
      'Sorry, Something went wrong there. See the action below !',
    restartApp: 'Click here to restart the app !',
    dragNDrop: 'Click to upload or drag and drop your file here',
    takePicture: 'Take a picture',
    uploadFile: 'Upload a file',
    signedOn: 'Signed on',
    location: 'Location',
    noAccess: 'You do not have access to this information',
    printRxLabel: 'Please select what to print:',
    printExportLabel: 'Please select what to export:',
    pd: 'PD',
    binocularPd: 'Binocular PD',
    notesOnRx: 'Notes on Rx',
    drRecommendation: 'Dr Recommendation ',
    all: 'All',
    startBlank: 'Start blank',
    noRoom: 'No room',
    room: 'Room',
    startFromVisit: 'Start from previous consultation',
    lockedOn: 'Locked on',
    lastUpdateOn: 'Last update on',
    lastUpdateBy: 'Last update by',
    visitDeniedAccessError:
      'You do not have access to view this patient file !',
    deniedAccessTitle: 'Access Denied',
    documentSize: 'Document Size',
    documentCategory: 'Document Category',
    attachment: 'Attachment',
    documentName: 'Document Name',
    addItemMessage: 'Add a new item',
    pdfNotSupported:
      'This PDF file cannot be attached to the referral at this time. Our team is currently working on making this possible and you will be notified when it will be available!',
    dob: 'DOB',
    previous: 'Previous',
    next: 'Next',
    weekly: 'Weekly',
    daily: 'Daily',
    available: 'Available',
    unAvailable: 'Not Available',
    lensometry: 'Lensometry',
    keratometry: 'Keratometry',
    autoRefractor: 'Auto Refractor',
    exportAction: 'Export',
    billing: 'Billing',
    multipleBuiltInTemplate:
      'More than 1 template was found, please select which one to use !',
    machinePullSuccess: 'Machine Interface has pulled successfully the data !',
    clientConnected: 'Client connected !',
    clientDisconnected: 'Client disconnected !',
    appointmentFor: 'Appointment for',
    successfullyCopied:
      'was successfully copied! Please move it to an available cell.',
    selfPaid: 'Self Paid',
    bookingAppointmentError:
      'This appointment might have already been booked on another computer, or the number of slots requested are not free !',
    insurer: 'Insurer',
    numberOfSlots: 'Number of Slots',
    book: 'Book',
    AppointmentType: 'Appointment Type',
    cancelAppointment: 'Cancel Appointment ',
    cancelledBy: 'Cancelled By',
    rescheduleAppointment: 'Reschedule Appointment',
    reschedule: 'Reschedule',
    viewWaitingList: 'View waiting list',
    showAllStores: 'Show Waiting List For All Stores',
    age: 'Age',
    home: 'Home',
    cell: 'Cell',
    work: 'Work',
    appDateAndTime: 'Appointment Date & Type',
    successfullyRescheduled: 'Appointment has been successfully rescheduled',
    lockScreenTitle: 'Your Session has Expired',
    enterPassword: 'Enter your password to pick up from where you left',
    notLabel: 'Not',
    resumeSession: 'Resume Session',
    iForgot: 'I forgot',
    doubleBook: 'Double Book ',
    sameSlot: 'Same Slot',
    first: 'First',
    last: 'Last',
    mins: 'mins',
    hour: 'hour',
    copyMessage:
      'Data was copied successfully, please paste it in the appropriate box',
    finalRxCopyMessage:
      "Final Rx copied successfully! Please paste in the current visit's appropriate box",
    time: 'Time',
    createAvailability: 'Create Availability',
    markAsUnavailable: 'Mark as unavailable',
    familyDoctor: 'Family Doctor',
    createUser: 'Create User',
    closedStoreTimeSlotErrorMessage:
      'The time slot you selected is outside store opening hours. You cannot create an availability !',
    providerTitle: 'Provider',
    loadMoreSummariesTitle: 'Load more summaries...',
    reset: 'Reset',
    emailRx: 'Email Rx',
    emailClRx: 'Email CLRx',
    emailRxSuccess: 'Rx sent successfully',
    invoice: 'Invoice',
    createInvoice: 'Create Invoice',
    invoiceAgain: 'Invoice again',
    showInvoice: 'Show invoice',
    invoiceOptions: 'Invoice Options',
    selectInvoiceOptions: 'Select an option',
    invoiceCreatedSuccessMessage: 'Invoice(s) {0} successfully created!',
    NoinvoiceCreatedMessage: 'No invoice created for this appointment!',
    sendToHarmony: 'Send to Harmony',
    sendToHarmonySuccessMessage: 'Data successfully sent to Topcon Harmony!',
    recentlyViewedPatients: 'Recently Viewed Patients',
    support: 'Support',
    agentAssumptionTitle: 'Agent Assumption Form',
    zendesk: 'Zendesk #',
    reason: 'Reason',
    agentLoginWarning:
      'This is a production account that uses private data. Do not enter any real patient data!',
    billingUpdateShortWarning:
      'Any changes made in this tile AFTER you have already created the invoice, will <style1>NOT</style1> reflect on that invoice... <style2>Read more</style2>',
    billingUpdateWarning:
      'Any changes made in this tile AFTER you have already created the invoice, will <style1>NOT</style1> reflect on that invoice. Please make sure to record those new changes by doing one of the following:\n\n' +
      '\n' +
      '- Open the invoice/claim in WINKpms and modify the existing invoice to reflect the changes you made in this section.\n' +
      '\n' +
      'OR\n' +
      '\n' +
      '- Create an invoice again. This will create a second invoice, but the first one will need to be cancelled via WINKpms. <style2>Read less</style2>',
    treatment: 'Treatment',
    plan: 'Plan',
    appUpdateTitle: 'New update is available',
    appUpdateSubtitle:
      'Please update the WINKemr app in the apple appstore to get the latest features and best experience.',
    openAppstore: 'Kindly open appstore to update app',
    appVersion: 'App Version',
    welcome: 'Welcome',
    somethingWentWrongVisitTitle: 'Something went wrong loading the visit!',
    reloadVisitTitle: 'Reload Visit',
    customiseDefaultExams: 'Default Exams',
    customiseExamDefinition: 'Exam Definition',
    yes: 'Yes',
    no: 'No',
    completeAlertTitle: 'Would you still like to complete the exam?',
    completeAlertMessage:
      'The following tiles have not been verified and will not be saved once the exam is completed: \n',
    lockAlertTitle: 'Would you still like to lock the exam?',
    lockAlertMessage:
      'The following tiles have not been verified and will not be saved once the exam is locked: \n',
    InvoiceAgainAlertTitle: 'Existing Invoice',
    InvoiceAgainAlertMessage:
      'You are creating an additional invoice for this visit.\nPlease make sure you cancel the original invoice in WINKpms to avoid duplicates.',
    notes: 'Notes',
    occupation: 'Occupation',
    examiningOptometrist: 'Examining Optometrist',
    gender: 'Gender',
    address: 'Address',
    email: 'Email',
    homeTelephone: 'Home Telephone',
    cellularTelephone: 'Cellular Telephone',
    dateOfBirth: 'Date of Birth',
    inactive: 'Inactive',
    createVisitType: 'Create Visit Type',
    newVisitType: 'New Visit Type',
    visitType: 'Visit Type',
    monocularPd: 'Monocular PD',
    referralAlertTitle: 'Would you still like to begin a referral letter?',
    referralAlertMessage: 'The following tiles have not been verified: \n',
    bvd: 'BVD',
    print: 'Print',
    insert: 'Insert',
    fax: 'Fax',
    save: 'Save',
    examRoom: 'Exam Room',
    patientRoom: 'Patient Room',
    characters: 'Characters',
    lines: 'Lines',
    va: 'VA',
    sph: 'Sph',
    cyl: 'Cyl',
    axis: 'Axis',
    add: 'Add',
    prism: 'Prism',
    calendarComments: 'Calendar comments',
    connectionMessage: 'The internet connection appears to be offline. Please check your internet connection',
    testingCondition: 'Testing Condition',
    updateVisitType: 'Update Visit Type',
    intakeForms: 'Intake Forms',
    otherForms: 'Other Forms',
    consentForms: 'Consent',
    appUpdateTitle: 'A new app update is available',
    appUpdateContent: 'Any unsaved data will be lost if you proceed with the update',
    doItLater: 'Do it later',
    loadMore: 'Load more...',
    today: 'Today',
    textEditor: 'Text Editor',
    preTests: "Pre-tests",
    homePhoneOrCellRequired: 'Either home phone or cell is required',
    refreshNow: 'Refresh now',
    lastRefreshed: 'Last updated at ',
    ['Access denied. Invalid credentials.']: 'Access denied. Invalid credentials.'
  },
  fr: {
    enterRegisteredEmail:
      'Veuillez entrer votre adresse courriel pour vous connecter à votre base de donées WINK\nou pour commencer un essai',
    trialWarning:
      "Ceci est la version d'essai qui utilise une base de données publique partagée. N'entrez aucune donnée réelle sur le patient. ",
    winkLink: 'Visitez www.winksoftware.com',
    emailAdres: 'Adresse courriel',
    connectToPms: 'Se connecter',
    tryForFree: 'Essayer',
    answerSecurityQuestion:
      'Veuillez répondre à la question de sécurité avant de soumettre la réponse',
    submitSecurityAnswer: 'Soumettre',
    unRegisteredEmail:
      "Cette adresse courriel n'a pas été enregistrée précédemment avec Wink",
    userName: "Nom d'utilisateur",
    password: 'Mot de passe', // NOSONAR
    enterCode: 'Entrez le code',
    submitLogin: 'Ouvrir la session',
    verifyCode: 'Vérifier',
    touchNotConfigured:
      "Votre compte n'est pas configuré pour utiliser l'application mobile à cet instant. Veuillez contacter le service à la clientèle",
    registrationScreenTitle: 'Registration WINKemr',
    loginscreenTitle: 'Se connecter à WINKemr',
    mfaCodeVerificationTitle: 'Vérification du code WINKemr',
    mfaCodeScanTitle: 'Numérisation du code QR WINKemr',
    mfaCodeScanned: "J'ai scanné le code",
    account: 'Compte',
    store: 'Magasin',
    securityQuestionsError:
      "Une erreur s'est produite en validant la question de sécurité. Veuillez réessayer.",
    registrationError:
      "Une erreur s'est produite en cherchant la version de l'application mobile. Veuillez réessayer.",
    fetchAccountsError:
      "Une erreur s'est produite en cherchant vos comptes. Veuillez réessayer.",
    loginFailed: "Erreur d'authentification",
    calendar: 'Calendrier',
    patient: 'Patient',
    back: 'Back',
    graph: 'Graphique',
    history: 'Historique',
    template: 'Modèle',
    templates: 'Modèles',
    settings: 'Paramètres',
    openFile: 'Dossier patient',
    startAppointment: 'Commencer',
    addVisit: 'Ajouter une consultation',
    createPatient: 'Ajouter un patient',
    logout: 'Déconnexion',
    newPatient: 'Nouveau patient',
    newDoctor: 'Ajouter docteur',
    newAppointment: 'Réservation rendez-vous',
    preExams: 'Prétests',
    exams: 'Examens',
    odSphere: 'OD Sphere',
    odCylinder: 'OD Cylinder',
    odAxis: 'OD Axis',
    odBase: 'OD Base',
    odPrism: 'OD Prism',
    odAdd: 'OD Add',
    osSphere: 'OS Sphere',
    osCylinder: 'OS Cylinder',
    osAxis: 'OS Axis',
    osBase: 'OS Base',
    osPrism: 'OS Prism',
    osAdd: 'OS Add',
    allNormal: 'Tous normaux',
    othersNormal: 'Autres normaux',
    paperForm: 'Paper form',
    predefinedOptions: 'Predefined options',
    selectionLists: 'Selection lists',
    groupedForm: 'Grouped form',
    refractionTest: 'Refraction test',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    extraLarge: 'Extra large',
    duplicate: 'Duplicate',
    serverError:
      "Une erreur s'est produite sur le serveur. Veuillez réessayer.\n\n(Erreur interne = {0})",
    pending: 'En attente',
    confirmed: 'confirmé',
    cancelled: 'Annulé',
    noShow: "Ne s'est pas présenté",
    waiting: 'En attente',
    viewWaitingList: "Afficher liste d'attente",
    waitingList: "Liste d'attente",
    waitingListComment: "Commentaire Liste d'attente",
    completed: 'Completé',
    start: 'Début',
    scheduledAt: 'Planifié pour',
    forDuration: 'pour',
    end: 'Fin',
    duration: 'Durée',
    minutes: 'minutes',
    minute: 'minute',
    hour: 'heure',
    hours: 'heures',
    day: 'jour',
    days: 'jours',
    halfAnHour: 'une demi-heure',
    status: 'Statut',
    doctor: 'Docteur',
    now: 'Maintenant',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    beforeYesterday: 'Avant hier',
    tomorrow: 'Demain',
    in2Days: 'Dans 2 jours',
    lockVisit: 'Vérouiller ',
    complete: 'Compléter',
    years: 'ans',
    ageM: 'âgé de',
    ageF: 'âgée de',
    recall: 'Rappel',
    noAccountsWarning:
      "Ce compte n'est pas accessible avec cette version de WINKemr.",
    sign: 'Signer',
    signed: 'Signé',
    diagnosis: 'Diagnostique',
    referral: 'Référence',
    finalRx: 'Rx Finale',
    printRx: 'Imprimer Rx',
    transferRx: 'Partager Rx',
    printClRx: 'Imprimer RxVC',
    printReferral: 'Imprimer Référence',
    printMedicalRx: 'Imprimer Rx médicale',
    printWithoutSign: 'Imprimer sans signature',
    printPatientFile: 'Imprimer Dossier Patient',
    patientFile: 'Dossier Patient',
    add: 'Add',
    remove: 'Suprimer',
    od: 'OD',
    os: 'OS',
    ou: 'OU',
    far: 'Loin',
    near: 'Près',
    dva: 'AVL',
    nva: 'AVP',
    maxLengthError: 'Trop de texte',
    minLengthError: 'Pas assez de texte',
    requiredError: 'Obligatoire',
    resume: 'Résumé',
    restart: 'Redémarrer',
    addFavorite: 'Ajouter favori',
    clear: 'Supprimer',
    favorites: 'Favoris',
    notStarted: 'Nouvel examen',
    copyToFinal: 'Rx finale',
    update: 'Confirmer',
    errorTitle: 'Erreur',
    errorsTitle: 'Erreurs',
    validationErrorMessage:
      'Veuillez vérifier que tout les champs ont des valeurs valides.',
    refractionTitle: 'Rx',
    removeItemError:
      "Veuillez effacer toutes les données avant de retirer cet item",
    unsupportedDocumentError: "Document {0} n'est pas supporté.",
    documentTrailTitle: '{0}',
    medicationRxTitle: 'Rx médicament',
    summaryTitle: 'Résumé',
    fetchItemError:
      "Une erreur s'est produite en chargeant les données. Veuillez essayer de nouveau.\n\n(Erreur interne = {1})",
    storeItemError:
      "Une erreur s'est produite en sauvegardant les données sur le serveur.\n\n(Erreur interne = {1})",
    initialiseError:
      "Une erreur s'est produite au demarage. Veuillez redémarrer l'application.\n\n(Erreur interne en chargeant {0} = {1})",
    maximumAddableGroupError: 'Vous ne pouvez pas ajouter plus que {0} {1}.',
    doctorWithoutVisitTypeError:
      "Docteur {0} n'est pas encore configuré pour utiliser l'application mobile.",
    searchCriteriumMissingError:
      'Veuillez entrez un critère pour la recherche.',
    noPatientsFound: 'Aucun patient trouvé',
    noDoctorsFound: 'Aucun docteur trouvé',
    drawingNotSavedWarning:
      "Attention: Votre dernière annotation n'a pas été sauvegardée.",
    scanEmailTitle: 'Dossier patient {0}',
    scanEmailBody:
      '<p>Veuillez trouvez le {0} pour patient {1}.</p><p>Cordialement</p><p>{2}</p>',
    emailAppUnavailableError:
      "Vous devez d'abord configurer l'application courriel sur votre iPad.",
    updateAppStore:
      "Veuillez effectuer les mises à jour pour WINKemr dans l'App store",
    cancel: 'Annuler',
    confirm: 'Confirmer',
    send: 'Envoyer',
    deleteVisitTitle: 'Supprimer une consultation',
    // deleteVisitQuestion:
    //   'Êtes-vous sûr de vouloir supprimer {0} du {1} de façon permanente ?',
    deleteVisitQuestion:
      'Cela supprimera de façon permanente cette consultation, y compris tous les diagnostics, interventions, notes et résultats. Êtes-vous absolument certain ?',
    deleteBoxText: 'Veuillez saisir <style1>supprimer</style1> pour continuer.',
    deleteText: 'supprimer',
    deletedVisitMessage: "Impossible d'ouvrir les visites supprimées !",
    findPatient: 'Entrer le nom du patient ou le #Z',
    findDoctor: 'Entrer le nom du docteur',
    visit: 'Consultation',
    translate: 'Traduire',
    stopTranslating: 'Arreter de traduire',
    document: 'document',
    importDataQuestion: 'Veuillez choisir pour importer',
    configuration: 'Config',
    nameStar: 'Please give the star a name',
    during: 'Pendant',
    drSignature: 'Signature',
    signedDate: 'Signé le',
    futureVisitDateError:
      'Vous ne pouvez pas ajouter une consultation dans le futur.',
    saveImageError:
      "Une erreur s'est produite en sauvegardant l'image {0} dans la base de données. Veuillez essayer de nouveau.",
    pmsImageSaveError:
      "Une erreur s'est produite en sauvegardant l'image dans le PMS",
    examDate: "Date de l'exam",
    healthCard: 'Carte maladie',
    configMissing:
      'Please go back to the first page and configure the {0} you want to use via the Config menu button.',
    emailSuccess: 'Email envoyé avec succès à {0}',
    faxSuccess: 'Fax envoyé avec succès à {0}',
    referralSuccess: 'Référence envoyé avec succès à {0}',
    referringPatientTo: 'Référer le patient à ',
    doctorReferralMissing: 'Veuillez sélectionner le docteur',
    digitalSignatureMissing: 'Veuillez avant insérer et placer votre signature',
    followUpTitle: 'Suivi',
    dynamicField: 'Champ dynamique',
    findRow: 'Recherche',
    view: 'Afficher',
    quickReply: 'Répondre',
    edit: 'Modifier',
    resend: 'Renvoyer',
    forward: 'Transférer',
    noDataFound: 'Aucune donnée trouvée !',
    deleteTitle: 'Supprimer',
    deleteReferralQuestion:
      'Êtes-vous sûr de vouloir supprimer la référence {0} du {1}  ?',
    manageUsers: 'Docteurs',
    deleteReferralTitle: 'Supprimer une référence',
    customisation: 'Personnalisation',
    from: 'De',
    to: 'Á',
    date: 'Date/Temps',
    comment: 'Commentaire',
    itemNotSelected: 'Aucun élément sélectionné',
    importDataNotFound: 'Aucun élément trouvée !',
    consultationDate: 'Date de la consultation',
    close: 'Fermer',
    open: 'Ouvrir',
    select: 'Sélectionner ',
    transferRxSuccess: 'Rx transféré avec succès !',
    exportDataSuccess: 'Données transférées avec succès !',
    NoCameraAccess: 'Webcam non trouvé !',
    flip: 'Retourner',
    snapshot: 'Snapshot',
    somethingWentWrongTitle: "Oops! Quelque chose s'est mal passé.",
    somethingWentWrongMessage:
      "Désolé, Quelque chose s'est mal passé. Utilisez l'action ci-dessous !",
    restartApp: "Cliquez ici pour redémarrer l'application !",
    dragNDrop: 'Cliquez pour téléverser ou déposez votre document ici',
    takePicture: 'Prendre une Photo',
    uploadFile: 'Téléverser un Fichier',
    signedOn: 'Signé le',
    location: 'Lieu',
    noAccess: 'Vous n’avez pas accès à cette information',
    printRxLabel: 'Veuillez sélectionner ce que vous souhaitez imprimer:', //need to change accordingly,
    printExportLabel: 'Veuillez sélectionner ce que vous souhaitez exporter:',
    pd: 'PD',
    binocularPd: 'PD Binoculaire',
    notesOnRx: 'Notes sur Rx',
    drRecommendation: 'Dr Recommandation',
    all: 'Tout',
    startBlank: 'Commencer avec un dossier vierge',
    noRoom: 'Pas de salle',
    room: 'Salle',
    startFromVisit: "Commencer sur la base d'une consultation précédente",
    lockedOn: 'Verrouillé le',
    lastUpdateOn: 'Modifié le',
    lastUpdateBy: 'Modifié par',
    visitDeniedAccessError: "vous n'avez pas accès à ce dossier patient !",
    deniedAccessTitle: 'Accès Refusé',
    documentSize: 'Taille du document',
    documentCategory: 'Catégorie du document',
    attachment: 'Attachment',
    documentName: 'Nom du document',
    addItemMessage: 'Ajouter un nouvel item',
    pdfNotSupported:
      'Ce document PDF ne peut être attaché à la référence pour le moment. Notre équipe de développment travaille présentement sur cette fonction afin de rendre cela possible et vous serez notifié dès que ce sera disponible!',
    dob: 'Date de Naissance',
    previous: 'Précédent',
    next: 'Suivant',
    weekly: 'Semaines',
    daily: 'Journalier',
    available: 'disponible',
    unAvailable: 'indisponible',
    lensometry: 'Lensométrie',
    keratometry: 'Kératométrie',
    autoRefractor: 'Auto Réfraction',
    exportAction: 'Exporter',
    billing: 'Facturation',
    multipleBuiltInTemplate:
      "Plus d'un modèle a été trouvé, veuillez sélectionner celui à utiliser !",
    machinePullSuccess:
      "L'interface machine a extrait avec succès les données !",
    clientConnected: 'Client connecté !',
    clientDisconnected: 'Client déconnecté !',
    apply: 'Appliquer',
    chooseDoctor: 'Choisir Docteur',
    appointmentFor: 'Le rendez vous de',
    successfullyCopied:
      'a été copié ! Veuillez le reporter à une autre plage horaire.',
    selfPaid: 'Paiement personnel',
    bookingAppointmentError:
      "Ce rendez-vous a peut-être déjà été réservé sur un autre ordinateur, ou le nombre de créneaux demandés n'est pas libre !",
    insurer: 'Assureur',
    numberOfSlots: 'Nombre de créneaux',
    book: 'Réserver',
    AppointmentType: 'Type rendez-vous',
    cancelAppointment: 'Annuler le rendez-vous ',
    cancelledBy: 'Annulé par',
    rescheduleAppointment: 'Re-planifier un rendez-vous',
    reschedule: 'Re-planifier',
    showAllStores: "Afficher la liste d'attente pour tous les magasins",
    age: 'Âge',
    home: 'Domicile',
    cell: 'Cellule',
    work: 'Travail',
    appDateAndTime: 'Date et type de rendez-vous',
    successfullyRescheduled: 'Le rendez-vous a été reporté avec succès',
    lockScreenTitle: 'Votre session a expiré',
    enterPassword: 'Entrez votre mot de passe pour récupérer votre session',
    notLabel: 'Pas',
    resumeSession: 'Reprendre la session',
    iForgot: "J'ai oublié",
    doubleBook: 'Double réservation',
    sameSlot: 'Même créneau',
    first: 'Premier',
    last: 'Dernier',
    mins: 'mins',
    copyMessage:
      'Les données ont été copiées avec succès, veuillez les coller dans la case appropriée',
    finalRxCopyMessage:
      'Rx Finale copié avec succès! Veuillez coller dans la case appropriée de la visite en cours',
    time: 'Temps',
    createAvailability: 'Créer une disponibilité',
    markAsUnavailable: 'Marquer comme indisponible',
    familyDoctor: 'Médecin de famille',
    createUser: 'Créer un utilisateur',
    closedStoreTimeSlotErrorMessage:
      'La case horaire sélectionnée est hors des heures d’ouverture du magasin. Vous ne pouvez pas créer de disponibilité !',
    providerTitle: 'Pourvoyeur',
    loadMoreSummariesTitle: 'Charger plus de résumés...',
    reset: 'Réinitialiser',
    emailRx: 'Envoyer Rx',
    emailClRx: 'Envoyer RxVC',
    emailRxSuccess: 'Rx envoyé avec succès',
    invoice: 'Facture',
    createInvoice: 'Créer une facture',
    invoiceAgain: 'Facturer à nouveau',
    showInvoice: 'Afficher facture',
    invoiceOptions: 'Options de Facture',
    selectInvoiceOptions: ' Sélectionez une option',
    invoiceCreatedSuccessMessage: 'Facture(s) {0} créée(s) avec succès!',
    NoinvoiceCreatedMessage: 'Aucune facture créée pour cette visite!',
    sendToHarmony: 'Envoyer vers Harmony',
    sendToHarmonySuccessMessage:
      'Données envoyées avec succès à Topcon Harmony!',
    recentlyViewedPatients: 'Patients Récemment Consultés',
    support: 'Support',
    agentAssumptionTitle: "Formulaire d'agent",
    zendesk: 'Zendesk #',
    reason: 'Raison',
    agentLoginWarning:
      "Il s'agit d'un compte de production qui utilise des données privées. N'entrez aucune donnée patient réelle !",
    billingUpdateShortWarning:
      'Toute modification apportée à cette section APRÈS avoir créé la facture <style1>NE SERA PAS</style1> reflétée sur cette facture... <style2>Lire plus</style2>',
    billingUpdateWarning:
      'Toute modification apportée à cette section APRÈS avoir créé la facture <style1>NE SERA PAS</style1> reflétée sur cette facture. Assurez-vous d’enregistrer les nouvelles modifications en procédant de l’une des manières suivantes:\n' +
      '\n' +
      '- Ouvrez la facture/réclamation dans WINKpms et modifiez la facture existante pour refléter les modifications apportées dans cette section. \n' +
      '\n' +
      'OU\n' +
      '\n' +
      '- Créer une facture à nouveau. Cela créera une deuxième facture, mais la première devra être annulée via WINKpms. <style2>Lire moins</style2>',
    treatment: 'Traitement',
    plan: 'Plan',

    appUpdateTitle: 'Une nouvelle mise à jour est disponible',
    appUpdateSubtitle:
      'Veuillez mettre à jour l’application WINKemr dans l’Appstore Apple pour obtenir les dernières fonctionnalités et la meilleure expérience.',
    openAppstore: 'Veuillez ouvrir l’appstore pour mettre à jour l’application',
    appVersion: 'Version de l’application',
    welcome: 'Bienvenue',
    somethingWentWrongVisitTitle:
      "Une erreur s'est produite lors du chargement de la visite !",
    reloadVisitTitle: 'Recharger la visite',
    customiseDefaultExams: 'Examens par défaut',
    customiseExamDefinition: 'Définition des examens',
    yes: 'Oui',
    no: 'Non',
    completeAlertTitle: 'Souhaitez-vous toujours compléter l’examen ?',
    completeAlertMessage:
      'Les tuiles suivantes n’ont pas été vérifiées et ne seront pas enregistrées une fois l’examen complété: \n',
    lockAlertTitle: 'Souhaitez-vous toujours verrouiller l’examen ?',
    lockAlertMessage:
      'Les tuiles suivantes n’ont pas été vérifiées et ne seront pas enregistrées une fois l’examen verrouillé: \n',
    InvoiceAgainAlertTitle: 'Facture existante',
    InvoiceAgainAlertMessage:
      'Vous avez créé une nouvelle facture pour cette visite.\nVeuillez vous assurer d’annuler la facture original pour éviter des doublons. ',
    notes: 'Notes',
    occupation: 'Profession',
    examiningOptometrist: 'Optométriste examinant',
    gender: 'Sexe',
    address: 'Adresse',
    email: 'Courriel',
    homeTelephone: 'Tél. maison',
    cellularTelephone: 'Tél. cell',
    dateOfBirth: 'Date de Naissance',
    inactive: 'Inactive',
    createVisitType: 'Créer un type de visite',
    newVisitType: 'Nouveau type de visite',
    visitType: 'Type de visite',
    monocularPd: 'PD Monoculaire',
    referralAlertTitle:
      'Souhaitez-vous toujours créer une lettre de référence?',
    referralAlertMessage: 'Les tuiles suivantes n’ont pas été vérifiées: \n',
    bvd: 'VTX',
    print: 'Imprimer',
    insert: 'Insérer',
    fax: 'Fax',
    save: 'Sauvegarder',
    examRoom: "Salle d'examen",
    patientRoom: 'Salle des patients',
    characters: 'Caractères',
    lines: 'Lignes',
    va: 'AV',
    sph: 'Sph',
    cyl: 'Cyl',
    axis: 'Axis',
    add: 'Add',
    prism: 'Prism',
    calendarComments: 'Commentaires de calendrier',
    connectionMessage: 'La connexion Internet semble être hors ligne. S`il vous plait, vérifiez votre connexion internet',
    testingCondition: 'Conditions de test',
    updateVisitType: 'Changer le type de visite',
    intakeForms: 'Formulaires d’admission',
    otherForms: 'Autres formes',
    consentForms: 'Consentement',
    appUpdateTitle: 'Une nouvelle mise à jour de l`application est disponible',
    appUpdateContent: 'Toutes les données non enregistrées seront perdues si vous procédez à la mise à jour',
    doItLater: 'Fais-le plus tard',
    loadMore: 'Charger plus...',
    today: 'Aujourd\'hui',
    textEditor: 'Éditeur de texte',
    preTests: "Pré-tests",
    homePhoneOrCellRequired: 'Un téléphone résidentiel ou cellulaire est requis',
    refreshNow: 'Actualiser maintenant',
    lastRefreshed: 'Dernière mise à jour à ',
    ['Access denied. Invalid credentials.']: 'Accès refusé. Identifiants invalides.'
  },
  es: {
    enterRegisteredEmail:
      'Introduce tu dirección de correo electrónico para conectarte a tu base de datos WINK o tratar con una base de datos de prueba',
    trialWarning:
      'Esta es una versión de prueba que utiliza una base de datos compartida pública. No ingreses ningún dato real del paciente.',
    winkLink: 'Visita www.winksoftware.com para obtener más información',
    emailAdres: 'Dirección de correo electrónico',
    connectToPms: 'Conectar',
    tryForFree: 'Pruébalo',
    answerSecurityQuestion:
      'Responde a la pregunta de seguridad antes de enviarla',
    submitSecurityAnswer: 'Enviar',
    unRegisteredEmail:
      'Esta dirección de correo electrónico no se registró antes con Wink',
    userName: 'Nombre de usuario',
    password: 'contraseña', // NOSONAR
    enterCode: 'Ingresar código',
    submitLogin: 'Iniciar sesión',
    verifyCode: 'Verificar',
    touchNotConfigured:
      'Tu cuenta aún no está configurada para usar la aplicación móvil. Contacta con el servicio de atención al cliente.',
    registrationScreenTitle: 'Registro WINKemr',
    loginscreenTitle: 'Iniciar sesión en WINKemr',
    mfaCodeVerificationTitle: 'Verificación del código WINKemr',
    mfaCodeScanTitle: 'Análisis del código QR de WINKemr',
    mfaCodeScanned: 'He escaneado el código',
    account: 'Cuenta',
    store: 'Tienda',
    securityQuestionsError:
      'Algo salió mal al intentar obtener la pregunta de seguridad del servidor. Inténtalo de nuevo.',
    registrationError:
      'Algo salió mal al intentar obtener la versión de la aplicación desde el servidor. Inténtalo de nuevo.',
    fetchAccountsError:
      'Algo salió mal al intentar obtener las cuentas del servidor. Inténtalo de nuevo.',
    loginFailed: 'Falló el inicio de sesión',
    calendar: 'Calendario',
    patient: 'Paciente',
    back: 'Volver',
    graph: 'Gráfico',
    history: 'Historia',
    template: 'Plantilla',
    templates: 'Plantillas',
    settings: 'Ajustes',
    openFile: 'Archivo del paciente',
    startAppointment: 'Iniciar visita',
    addVisit: 'Añadir consulta',
    createPatient: 'Crear paciente',
    logout: 'Cerrar sesión',
    newPatient: 'Nuevo paciente',
    newDoctor: 'Agregar un médico',
    newAppointment: 'Reservar una cita',
    preExams: 'Previo a la prueba',
    exams: 'Exámenes',
    odSphere: 'OD Sphere',
    odCylinder: 'OD Cylinder',
    odAxis: 'OD Axis',
    odBase: 'OD Base',
    odPrism: 'OD Prism',
    odAdd: 'OD Add',
    osSphere: 'OS Sphere',
    osCylinder: 'OS Cylinder',
    osAxis: 'OS Axis',
    osBase: 'OS Base',
    osPrism: 'OS Prism',
    osAdd: 'OS Add',
    allNormal: 'Todo normal',
    othersNormal: 'Otros son normales',
    paperForm: 'Formulario en papel',
    predefinedOptions: 'Opciones predefinidas',
    selectionLists: 'Listas de selección',
    groupedForm: 'Formulario agrupado',
    refractionTest: 'Prueba de refracción',
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    extraLarge: 'Extra grande',
    duplicate: 'Duplicar',
    serverError:
      'Algo salió mal en el servidor. Inténtalo de nuevo. (Error interno = {0})',
    pending: 'Pendiente',
    confirmed: 'Confirmado',
    cancelled: 'Cancelado',
    noShow: 'Ningún paciente',
    waiting: 'Espera',
    waitingList: 'Lista de espera',
    waitingListComment: 'Comentario de la lista de espera',
    completed: 'Terminado',
    start: 'Comenzar',
    scheduledAt: 'Programado a',
    forDuration: 'por',
    end: 'Terminar',
    duration: 'Duración',
    minutes: 'minutos',
    minute: 'minuto',
    hours: 'horas',
    day: 'día',
    days: 'días',
    halfAnHour: 'media hora',
    status: 'Estado',
    doctor: 'Médico',
    now: 'Ahora',
    today: 'Hoy',
    yesterday: 'Ayer',
    beforeYesterday: 'Antes de ayer',
    tomorrow: 'Mañana',
    in2Days: 'En 2 días',
    lockVisit: 'Bloqueo',
    complete: 'Completar',
    years: 'años',
    ageM: 'edad',
    ageF: 'edad',
    recall: 'Volver a llamar',
    noAccountsWarning:
      'No hay cuentas compatibles con esta versión de WINKemr.',
    sign: 'Firmar',
    signed: 'Firmado',
    diagnosis: 'Diagnóstico',
    referral: 'Referencia',
    finalRx: 'Rx final',
    printRx: 'Imprimir Rx',
    transferRx: 'Compartir Rx',
    printClRx: 'Imprimir ClRx',
    printReferral: 'Imprimir referencia',
    printMedicalRx: 'Imprimir Rx médico',
    printWithoutSign: 'Imprimir sin firma',
    printPatientFile: 'Imprimir archivo de paciente',
    patientFile: 'Archivo del paciente',
    add: 'Adición',
    remove: 'Quitar',
    od: 'OD',
    os: 'OS',
    ou: 'OU',
    far: 'Lejos',
    near: 'Cerca',
    dva: 'AVL',
    nva: 'AVC',
    maxLengthError: 'Demasiado texto',
    minLengthError: 'No hay suficiente texto',
    requiredError: 'Obligatorio',
    resume: 'Resumen',
    restart: 'Reiniciar',
    addFavorite: 'Añadir favorito',
    clear: 'Quitar',
    favorites: 'Común',
    notStarted: 'Nuevo examen',
    copyToFinal: 'Rx final',
    update: 'Actualizar',
    errorTitle: 'Error',
    errorsTitle: 'Errores',
    validationErrorMessage:
      'Verifica que todos los campos contengan valores válidos.',
    refractionTitle: 'Rx',
    removeItemError:
      'Borra todos los datos antes de retirar un item.',
    unsupportedDocumentError: 'No se puede mostrar el documento {0}.',
    documentTrailTitle: '{0} ',
    medicationRxTitle: 'Medicación Rx',
    summaryTitle: 'Resumen',
    fetchItemError:
      'Algo salió mal al intentar obtener datos {0} del servidor. Inténtalo de nuevo. (Error interno = {1})',
    storeItemError:
      'Algo salió mal al intentar guardar los datos {0} en el servidor. (Error interno = {1})',
    initialiseError:
      'Algo ha salido mal durante la inicialización. Elimine y reinicie la aplicación. (Búsqueda de errores internos {0} = {1})',
    maximumAddableGroupError: 'No se puede añadir más de {0} {1}.',
    doctorWithoutVisitTypeError:
      'El médico {0} aún no está configurado para el RME en la base de datos.',
    searchCriteriumMissingError: 'Introduce un criterio de búsqueda.',
    noPatientsFound: 'No se encontró ningún paciente',
    noDoctorsFound: 'No se encontró ningún médico',
    drawingNotSavedWarning: 'Atención: Tu último dibujo no se guardó.',
    scanEmailTitle: 'Archivo del paciente {0}',
    scanEmailBody:
      '<p>Se adjunta el {0} para el paciente {1}.</p><p>Que tengas un buen día</p><p>{2}</p>',
    emailAppUnavailableError:
      'Configura la aplicación de correo electrónico del iPad.',
    updateAppStore:
      'Actualiza la aplicación WINKemr en la tienda de aplicaciones de Apple.',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    send: 'Enviar',
    deleteVisitTitle: 'Eliminar la consulta',
    // deleteVisitQuestion:
    //   '¿Estás seguro que deseas eliminar permanentemente el {0} de {1} ?',
    deleteVisitQuestion:
      'Esto eliminará de forma permanente esta consulta, incluidos todos los diagnósticos, procedimientos, notas y resultados. ¿Estás absolutamente seguro?',
    deleteBoxText: 'Por favor, escriba <style1>eliminar</style1> para continuar.',
    deleteText: 'eliminar',
    deletedVisitMessage: '¡No se puede abrir las visitas eliminadas!',
    findPatient: 'Búsqueda por nombre de paciente o #Z',
    findDoctor: 'Búsqueda por nombre del médico',
    visit: 'Consulta',
    translate: 'Traducir',
    stopTranslating: 'Dejar de traducir',
    document: 'documento',
    importDataQuestion: 'Elige importar',
    configuration: 'Configuración',
    nameStar: 'Ponle un nombre a la estrella',
    during: 'Durante',
    drSignature: 'Firma',
    signedDate: 'Fecha firmada',
    futureVisitDateError: 'No puedes agregar una consulta en el futuro',
    saveImageError:
      'Algo salió mal al guardar tu imagen {0} en la base de datos. Inténtalo de nuevo.',
    pmsImageSaveError:
      'Algo salió mal al guardar tu imagen en el PMS. Puedes intentarlo de nuevo.',
    examDate: 'Fecha del examen',
    healthCard: 'Tarjeta de salud',
    configMissing:
      'Vuelve a la primera página y configura el {0} que desea usar a través del botón de menú Configuración.',
    emailSuccess: 'Correo electrónico enviado correctamente a {0}',
    faxSuccess: 'Fax enviado correctamente a {0}',
    referralSuccess: 'Remisión enviada con éxito a {0}',
    referringPatientTo: 'Remitir al paciente a',
    doctorReferralMissing: 'Selecciona el médico',
    digitalSignatureMissing:
      'Introduce y coloca primero el campo de la firma digital',
    followUpTitle: 'Seguimiento',
    dynamicField: 'Campo dinámico',
    findRow: 'Buscar',
    view: 'Vista',
    quickReply: 'Respuesta rápida',
    edit: 'Editar',
    resend: 'Reenviar',
    forward: 'Adelantar',
    noDataFound: '¡No existe carta de referencia!',
    deleteTitle: 'Borrar',
    deleteReferralQuestion:
      '¿Estás seguro que deseas eliminar la referencia {0} de {1} ?',
    manageUsers: 'Médicos',
    deleteReferralTitle: 'Eliminar la remisión',
    customisation: 'Personalizar',
    from: 'De',
    to: 'Para',
    date: 'Fecha/hora',
    comment: 'Comentario',
    itemNotSelected: 'No se seleccionó ningún artículo',
    importDataNotFound: '¡No se encontraron datos para importar!',
    consultationDate: 'Fecha de consulta',
    close: 'Cerrar',
    apply: 'Aplicar',
    open: 'Abrir',
    select: 'Seleccionar',
    chooseDoctor: 'Elige el médico',
    transferRxSuccess: '¡Rx transferido con éxito!',
    exportDataSuccess: '¡Datos exportados con éxito!',
    NoCameraAccess: 'Sin acceso a la cámara',
    flip: 'Voltear',
    snapshot: 'Captura',
    somethingWentWrongTitle: '¡Vaya! Algo ha salido mal.',
    somethingWentWrongMessage:
      'Lo sentimos, algo salió mal. ¡Ver la acción a continuación!',
    restartApp: '¡Haz clic aquí para reiniciar la aplicación!',
    dragNDrop: 'Haz clic para cargar o arrastra y suelta tu archivo aquí',
    takePicture: 'Tomar una foto',
    uploadFile: 'Subir un archivo',
    signedOn: 'Firmado en',
    location: 'Ubicación',
    noAccess: 'No tienes acceso a esta información',
    printRxLabel: 'Selecciona lo que deseas imprimir:',
    printExportLabel: 'Selecciona lo que deseas exportar:',
    pd: 'DP',
    binocularPd: 'DP binocular',
    notesOnRx: 'Notas sobre Rx',
    drRecommendation: 'Recomendación adicional',
    all: 'Todo',
    startBlank: 'Empezar en blanco',
    noRoom: 'No hay sala',
    room: 'Sala',
    startFromVisit: 'Inicio de la consulta previa',
    lockedOn: 'Bloqueado',
    lastUpdateOn: 'última actualización en',
    lastUpdateBy: 'última actualización por',
    visitDeniedAccessError:
      '¡No tienes acceso para ver este archivo del paciente!',
    deniedAccessTitle: 'Acceso denegado',
    documentSize: 'Tamaño del documento',
    documentCategory: 'Categoría del documento',
    attachment: 'Documento adjunto',
    documentName: 'Nombre del documento',
    addItemMessage: 'Añadir un nuevo item',
    pdfNotSupported:
      'Este archivo PDF no se puede adjuntar a la referencia en este momento. Actualmente, nuestro equipo está trabajando para que esto sea posible y te notificaremos cuando esté disponible.',
    dob: 'Fecha de Nacimiento',
    previous: 'Anterior',
    next: 'Próximo',
    weekly: 'Semanal',
    daily: 'Diario',
    available: 'Disponible',
    unAvailable: 'No disponible',
    lensometry: 'Lensometría',
    keratometry: 'Queratometría',
    autoRefractor: 'Autorefractor',
    exportAction: 'Exportar',
    billing: 'Facturación',
    multipleBuiltInTemplate:
      'Se encontró más de 1 plantilla, seleccione cuál usar.',
    machinePullSuccess:
      'La interfaz de la máquina ha extraído con éxito los datos.',
    clientConnected: '¡Cliente conectado!',
    clientDisconnected: '¡Cliente desconectado!',
    appointmentFor: 'Cita para',
    successfullyCopied:
      '¡fue copiado con éxito! Muévelo a una celda disponible.',
    selfPaid: 'Pagado',
    bookingAppointmentError:
      'Es posible que esta cita ya esté reservada en otro ordenador o que el número de plazas solicitadas no esté libre.',
    insurer: 'Aseguradora',
    numberOfSlots: 'Número de plazas',
    book: 'Agendar',
    AppointmentType: 'Tipo de cita',
    cancelAppointment: 'Cancelar cita',
    cancelledBy: 'Cancelado por',
    rescheduleAppointment: 'Reprogramar la cita',
    reschedule: 'Reprogramar',
    viewWaitingList: 'Ver lista de espera',
    showAllStores: 'Mostrar lista de espera para todas las tiendas',
    age: 'Edad',
    home: 'Hogar',
    cell: 'Celda',
    work: 'Trabajar',
    appDateAndTime: 'Fecha y tipo de cita',
    successfullyRescheduled: 'La cita ha sido reprogramada con éxito',
    lockScreenTitle: 'Su sesión ha expirado',
    enterPassword:
      'Introduce tu contraseña para continuar desde donde lo dejaste',
    notLabel: 'No',
    resumeSession: 'Reanudar la sesión',
    iForgot: 'Me olvidé',
    doubleBook: 'Doble reserva',
    sameSlot: 'Misma plaza',
    first: 'Primero',
    last: 'último',
    mins: 'mins',
    hour: 'hora',
    copyMessage:
      'Los datos se copiaron correctamente, pégalos en la casilla correspondiente',
    finalRxCopyMessage:
      '¡Rx final copiado con éxito! Introduce en la casilla correspondiente a la visita actual',
    time: 'Tiempo',
    createAvailability: 'Crear disponibilidad',
    markAsUnavailable: 'Marcar como no disponible',
    familyDoctor: 'Médico de familia',
    createUser: 'Crear usuario',
    closedStoreTimeSlotErrorMessage:
      'Los horarios que seleccionaste están fuera del horario de apertura de la tienda. ¡No puedes crear una disponibilidad!',
    providerTitle: 'Proveedor',
    loadMoreSummariesTitle: 'Cargar más resúmenes...',
    reset: 'Reiniciar',
    emailRx: 'Correo electrónico de Rx',
    emailClRx: 'Correo electrónico de CLRx',
    emailRxSuccess: 'Rx enviado con éxito',
    invoice: 'Factura',
    createInvoice: 'Crear factura',
    invoiceAgain: 'Facturar de nuevo',
    showInvoice: 'Mostrar factura',
    invoiceOptions: 'Opciones de factura',
    selectInvoiceOptions: 'Seleccione una opción',
    invoiceCreatedSuccessMessage: '¡Factura(s) {0} creada(s) con éxito!',
    NoinvoiceCreatedMessage: '¡Ninguna factura creada para esta cita!',
    sendToHarmony: 'Enviar a Harmony',
    sendToHarmonySuccessMessage: '¡Datos enviados con éxito a Topcon Harmony!',
    recentlyViewedPatients: 'Pacientes vistos recientemente',
    support: 'Soporte',
    agentAssumptionTitle: 'Formulario de asunción del agente',
    zendesk: 'Número de Zendesk',
    reason: 'Razón',
    agentLoginWarning:
      'Esta es una cuenta de producción que utiliza datos privados. ¡No ingrese ningún dato real del paciente!',
    billingUpdateShortWarning:
      'Los cambios realizados en esta pantalla DESPUÉS de crear la factura <style1>NO</style1> se reflejarán en esa factura... <style2>Lee mas</style2>',
    billingUpdateWarning:
      'Los cambios realizados en esta pantalla DESPUÉS de crear la factura <style1>NO</style1> se reflejarán en esa factura. Si realiza cambios después de haber creado la factura, asegúrese de registrar los cambios mediante una de las siguientes acciones:\n\n' +
      '- Abra la factura/reclamación en WINKpms y modifique la factura existente para reflejar los cambios realizados en esta sección.\n' +
      'O\n' +
      '- Cree una factura de nuevo. Esto creará una segunda factura, por lo que la anterior tendrá que ser cancelada a través de WINKpms. <style2>Leer menos</style2>',
    treatment: 'Tratamiento',
    plan: 'Plan',
    appUpdateTitle: 'La nueva actualización está disponible',
    appUpdateSubtitle:
      'Actualiza la aplicación WINKemr en el apple appstore para obtener las últimas características y la mejor experiencia.',
    openAppstore:
      'Abre la tienda de aplicaciones para actualizar la aplicación',
    appVersion: 'Versión de la aplicación',
    welcome: 'Bienvenido',
    somethingWentWrongVisitTitle: '¡Algo salió mal al cargar la visita!',
    reloadVisitTitle: 'Recargar la visita',
    customiseDefaultExams: 'Definir los exámenes por defecto',
    customiseExamDefinition: 'Personalizar la definición del examen',
    yes: 'Si',
    no: 'No',
    completeAlertTitle: '¿Todavía te gustaría completar el examen?',
    completeAlertMessage:
      'Los siguientes mosaicos no se han verificado y no se guardarán una vez que se complete el examen: \n',
    lockAlertTitle: '¿Aún desea bloquear el examen?',
    lockAlertMessage:
      'Los siguientes mosaicos no se han verificado y no se guardarán una vez que se bloquee el examen: \n',
    readMore: 'Lee mas',
    readLess: 'Leer menos',
    InvoiceAgainAlertTitle: 'Factura existente',
    InvoiceAgainAlertMessage:
      'Está creando una factura adicional para esta visita.\n' +
      'Asegúrese de cancelar la factura original en WINKpms para evitar duplicados.',
    notes: 'Notas',
    occupation: 'Ocupación',
    examiningOptometrist: 'examen de optometrista',
    gender: 'Género',
    address: 'Dirección',
    email: 'Email',
    homeTelephone: 'Teléfono de casa',
    cellularTelephone: 'Telefono celular',
    dateOfBirth: 'Fecha de nacimiento',
    inactive: 'Inactivo',
    createVisitType: 'Crear tipo de visita',
    newVisitType: 'Nuevo tipo de visita',
    visitType: 'Tipo de visita',
    monocularPd: 'Monocular DP',
    referralAlertTitle:
      '¿Todavía le gustaría comenzar una carta de recomendación?',
    referralAlertMessage: 'Los siguientes mosaicos no han sido verificados\n',
    bvd: 'DVP',
    print: 'Imprimir',
    insert: 'insertar',
    fax: 'Fax',
    save: 'Salvar',
    examRoom: 'Cuarto de examen',
    patientRoom: 'Cuarto del paciente',
    characters: 'caracteres',
    lines: 'Líneas',
    va: 'VA',
    sph: 'Esf',
    cyl: 'Cil',
    axis: 'Eje',
    add: 'Adición',
    prism: 'Prisma',
    calendarComments: 'Comentarios del calendario',
    connectionMessage: 'La conexión a Internet parece estar fuera de línea. Por favor revise su conexion a internet',
    testingCondition: 'Condición de prueba',
    updateVisitType: 'Actualizar tipo de visita',
    intakeForms: 'Formularios de admisión',
    otherForms: 'Otras formas',
    consentForms: 'Consentir',
    appUpdateTitle: 'Hay una nueva actualización de la aplicación disponible',
    appUpdateContent: 'Cualquier dato no guardado se perderá si continúa con la actualización.',
    doItLater: 'Hazlo después',
    loadMore: 'Carga más',
    today: 'Hoy',
    textEditor: 'Editor de texto',
    preTests: "Pruebas previas",
    homePhoneOrCellRequired: 'Se requiere teléfono residencial o celular',
    refreshNow: 'Actualizar ahora',
    lastRefreshed: 'Última actualización en ',
    ['Access denied. Invalid credentials.']: 'Acceso denegado. Credenciales no válidas.'
  },
});

//console.log('Interface language is: '+strings.getInterfaceLanguage());

const supportedLanguages: string[] = [
  'en-US',
  '🇺🇸',
  'en-CA',
  '🇨🇦',
  'en-UK',
  '🇬🇧',
  'fr-CA',
  '🇫🇷',
  'es-ES',
  '🇪🇸',
];

let userLanguage: string;

export function getUserLanguage(): string {
  return userLanguage;
}

export function getUserLanguageIcon(): string {
  let languageIndex: number = supportedLanguages.indexOf(getUserLanguage());
  if (languageIndex < 0) {
    languageIndex = 0;
  }
  return supportedLanguages[languageIndex + 1];
}

export function getUserLanguageShort(): string {
  if (userLanguage === undefined) {
    return undefined;
  }
  return userLanguage.substring(0, 2);
}

async function setUserLanguage(locale: string) {
  __DEV__ && console.log('Switching language to ' + locale);
  userLanguage = locale;
  strings.setLanguage(userLanguage.substring(0, 2));
  Moment.locale(userLanguage.substring(0, 2));
  //TODO: set number formatting localised
  cacheDefinitions(userLanguage);
}

export function switchLanguage() {
  let language = getUserLanguage();
  __DEV__ && console.log('current language = ' + language);
  let languageIndex = supportedLanguages.indexOf(language);
  languageIndex = (languageIndex + 2) % supportedLanguages.length;
  language = supportedLanguages[languageIndex];
  AsyncStorage.setItem('userLanguage', language);
  setUserLanguage(language);
}

AsyncStorage.getItem('userLanguage').then((userLanguage) => {
  if (userLanguage === null || userLanguage === undefined) {
    userLanguage = strings.getInterfaceLanguage();
  }
  if (supportedLanguages.indexOf(userLanguage) < 0) {
    userLanguage = supportedLanguages[0];
  }
  setUserLanguage(userLanguage);
});
